module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Regular.ca6306f1.woff2";